import React from 'react';
import swal from 'sweetalert';
import ReactGA from 'react-ga';
import actions from 'api/actions';

const ValidatedForm = (Child, defaultFields, validations) => {
  return class ValidatedForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        errors: {},
        success: false,
        submitted: false,
        fields: defaultFields,
      };
    }

    create = formData => {
      const { errors, ...fields } = formData;
      const { append } = this.props;
      let { message } = fields;
      message = message + ` ${append}`;

      actions
        .post('leads', { ...fields, message })
        .then(r => this.setState({ success: true }))
        .catch(e =>
          swal(
            'Error',
            'Sorry, something went wrong on our end. Please refresh and try again.',
            'error',
          ),
        );
    };

    handleSubmit = e => {
      e.preventDefault();
      const errors = {};
      const { fields } = this.state;

      for (let key in fields) {
        if (
          Object.prototype.hasOwnProperty.call(fields, key) &&
          validations[key] &&
          !validations[key](fields[key])
        ) {
          errors[key] = true;
        }
      }

      if (Object.keys(errors).length > 0 || Object.keys(fields).length < 1) {
        this.setState({ errors, submitted: true });
      } else {
        ReactGA.event({
          category: 'Interest',
          action: 'Submit lead form',
        });
        this.create(fields);
      }
    };

    handleChange = e => {
      const { name, value } = e.target;

      this.setState(state => {
        if (state.submitted) {
          state.errors[name] = validations[name] && !validations[name](value);
        }

        state.fields[name] = value;
        return state;
      });
    };

    render() {
      return (
        <Child
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
          {...this.props}
          {...this.state}
        />
      );
    }
  };
};

export default ValidatedForm;
